import { Avatar } from '@eventbrite/eds-avatar';
import { Button } from '@eventbrite/eds-button';
import { CalendarChunky as CalendarChunkySVG } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { setAction } from '@eventbrite/user-action-cookie';
import React, { useContext } from 'react';
import { ConfirmationModalBody } from '../../../../components/ConfirmationOverlay';
//TODO cleanup shared component imports
import { Toggle } from '../../../../components/Toggle';
import {
    GA_FOLLOWED_ORGANIZERS_FILTER_ATTEMPT,
    GA_SEARCH_CATEGORY,
} from '../../../../constants/analytics';
import {
    FOLLOWED_ORGS_FILTER_VALUE,
    SPECIAL_FILTER,
} from '../../../../constants/filters';
import OverlayContext from '../../../../context/Overlay';
import { SelectedFilters } from '../../../../types/index';

const SIGNIN_CONFIRMATION_TEXT = gettext(
    'Sign in to see events </br>from organizers you follow',
);

const SigninConfirmationModalContent = () => {
    const referrer = `${window.location.pathname}${
        window.location.search ? window.location.search + '&' : '?'
    }followed_orgs=1`;

    return (
        <ConfirmationModalBody
            contentHeader={
                <Avatar
                    iconType={<CalendarChunkySVG />}
                    backgroundColor="grey-100"
                />
            }
            contentFooter={
                <Button
                    type="link"
                    style="fill"
                    href={`/signin/?referrer=${referrer}`}
                >
                    {gettext('Get Started')}
                </Button>
            }
        >
            <h2 className="eds-text-hs eds-text--center">
                <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: SIGNIN_CONFIRMATION_TEXT.toString(),
                    }}
                />
            </h2>
        </ConfirmationModalBody>
    );
};

interface FollowedOrganizersFilterButtonProps {
    selectedFilters?: SelectedFilters;
    onFilterChange?: Function;
    handleRemoveFilter?: Function;
    isAuthenticated?: boolean;
}

const FollowedOrganizersFilterButton = (
    props: FollowedOrganizersFilterButtonProps,
) => {
    const { setOverlayConfig } = useContext(OverlayContext) || {};

    const loggedInHandleClick = () => {
        !props.selectedFilters?.followedOrganizers
            ? props.onFilterChange?.(
                  SPECIAL_FILTER,
                  FOLLOWED_ORGS_FILTER_VALUE,
                  true,
              )
            : props.handleRemoveFilter?.({ special: true });
    };

    const loggedOutHandleClick = () => {
        trackAnalyticsEvent({
            category: GA_SEARCH_CATEGORY,
            action: GA_FOLLOWED_ORGANIZERS_FILTER_ATTEMPT,
        });

        setAction({
            action: 'FollowedOrganizerFilterAttempt',
            origin: '/',
        });

        setOverlayConfig?.({
            type: 'simple',
            children: <SigninConfirmationModalContent />,
        });
    };

    return (
        <div className="eds-align--center eds-align--space-between eds-l-pad-right-3 eds-l-pad-left-2">
            <p className="eds-l-pad-right-6">
                {gettext('Only show events from organizers I follow')}
            </p>
            <Toggle
                shouldNotOptimisticUpdate={!props.isAuthenticated}
                onClick={
                    props.isAuthenticated
                        ? loggedInHandleClick
                        : loggedOutHandleClick
                }
                renderDisplayValue={(isActive) =>
                    isActive ? gettext('On') : gettext('Off')
                }
                isActive={props.selectedFilters?.followedOrganizers || false}
            />
        </div>
    );
};

export default FollowedOrganizersFilterButton;
